// ======================================================================
// File Name       : Root
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import Main from '../containers/MainContainer';
import LoginContainer from '../containers/LoginContainer';
import ChangePasswordContainer from '../containers/ChangePasswordContainer';
import SystemHintDialog from './modal/SystemHintDialog';
import PasswordResetContainer from '../containers/passwordReset/PasswordResetContainer';
import PasswordResetCompleteContainer from '../containers/passwordReset/PasswordResetCompleteContainer';
import * as Path from '../constants/PathConstants';

const history = createHistory();
const Root = ({ store }) =>
  (<Provider store={store}>
    <Router history={history}>
      <Switch>
        {/* Step9.0.0 START */}
        <Route exact path="/login" component={Main} />
        {/* Step9.0.0 END */}
        <Route exact path="/hint" component={SystemHintDialog} />
        <Route exact path="/changePassword" component={ChangePasswordContainer} />
        {/* sprint_20230619_tma START */}
        <Route exact path={Path.PASSWORD_RESET_REQUEST} component={PasswordResetContainer} />
        <Route exact path={Path.SUPERUSER_PASSWORD_RESET_REQUEST} component={PasswordResetContainer} />
        <Route exact path={Path.PASSWORD_RESET_REQUEST_COMPLETE} component={PasswordResetCompleteContainer} />
        {/* sprint_20230619_tma END */}
        <Route path="/*" component={Main} />
      </Switch>
    </Router>
  </Provider>);

Root.propTypes = {
  store: PropTypes.shape().isRequired,
};

export default Root;
